// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"585":"TikTokApplication","593":"InstagramApplication"}[chunkId] || chunkId) + "." + {"214":"5f47c616","585":"18ab7bf9","593":"299130d6","872":"04ca1b6f","978":"a5ffa854"}[chunkId] + ".js";
};